import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { Table } from "@tiptap/extension-table";
import { TableRow } from "@tiptap/extension-table-row";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import TextAlign from "@tiptap/extension-text-align";
import { Bold, Italic, Underline, List, ListOrdered, Heading2, Heading3, AlignLeft, AlignCenter, AlignJustify, Table2, Undo2, Redo2, Pilcrow } from "lucide-react";

const B = ({ on, active, title, children, id }) => (
  <button type="button" title={title} onMouseDown={(e) => { e.preventDefault(); on(); }} data-testid={`editor-btn-${id}`}
    className={`h-8 w-8 rounded flex items-center justify-center transition-colors ${active ? "bg-[#0A2540] text-white" : "text-slate-700 hover:bg-slate-100"}`}>{children}</button>
);

function Toolbar({ ed }) {
  const c = () => ed.chain().focus();
  const items = [
    ["bold", "Grassetto", Bold, () => c().toggleBold().run(), ed.isActive("bold")],
    ["italic", "Corsivo", Italic, () => c().toggleItalic().run(), ed.isActive("italic")],
    ["underline", "Sottolineato", Underline, () => c().toggleUnderline().run(), ed.isActive("underline")],
    ["p", "Paragrafo", Pilcrow, () => c().setParagraph().run(), ed.isActive("paragraph")],
    ["h2", "Titolo", Heading2, () => c().toggleHeading({ level: 2 }).run(), ed.isActive("heading", { level: 2 })],
    ["h3", "Sottotitolo", Heading3, () => c().toggleHeading({ level: 3 }).run(), ed.isActive("heading", { level: 3 })],
    ["ul", "Elenco puntato", List, () => c().toggleBulletList().run(), ed.isActive("bulletList")],
    ["ol", "Elenco numerato", ListOrdered, () => c().toggleOrderedList().run(), ed.isActive("orderedList")],
    ["left", "Allinea a sinistra", AlignLeft, () => c().setTextAlign("left").run(), ed.isActive({ textAlign: "left" })],
    ["center", "Centra", AlignCenter, () => c().setTextAlign("center").run(), ed.isActive({ textAlign: "center" })],
    ["justify", "Giustifica", AlignJustify, () => c().setTextAlign("justify").run(), ed.isActive({ textAlign: "justify" })],
    ["table", "Inserisci tabella", Table2, () => c().insertTable({ rows: 3, cols: 2, withHeaderRow: true }).run(), false],
    ["undo", "Annulla", Undo2, () => c().undo().run(), false],
    ["redo", "Ripeti", Redo2, () => c().redo().run(), false],
  ];
  return (
    <div className="flex flex-wrap gap-0.5 p-1.5 border-b border-slate-200 bg-slate-50 sticky top-0 z-10" data-testid="editor-toolbar">
      {items.map(([id, t, I, on, a]) => <B key={id} id={id} title={t} on={on} active={a}><I className="h-4 w-4" /></B>)}
    </div>
  );
}

export function ContractEditor({ html, editable, onChange }) {
  const ed = useEditor({
    extensions: [StarterKit, Table.configure({ resizable: false }), TableRow, TableHeader, TableCell, TextAlign.configure({ types: ["heading", "paragraph"] })],
    content: html, editable, onUpdate: ({ editor }) => onChange(editor.getHTML()),
  }, [html, editable]);
  if (!ed) return null;
  return (
    <div className="border border-slate-200 rounded-lg bg-white overflow-hidden" data-testid="contract-editor">
      {editable && <Toolbar ed={ed} />}
      <EditorContent editor={ed} className="contract-doc max-h-[70vh] overflow-y-auto px-10 py-8" />
    </div>
  );
}
